import BasicLayout from "@/layouts/basic-layout";
import CancelMailingProvider from "./cancle-mailling-provider";
import CancelView from "./cancel-view";
import CancelFooter from "./cancel-footer";
import CancelPageWrapper from "./cancel-wrapper";
import CancelError from "./cancel-error";

const CancelMailingList = () => {
  return (
    <BasicLayout>
      <CancelMailingProvider>
        <CancelPageWrapper fallback={<CancelError />}>
          <>
            <CancelView />
            <CancelFooter />
          </>
        </CancelPageWrapper>
      </CancelMailingProvider>
    </BasicLayout>
  );
};
export default CancelMailingList;

//======================
